import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { getBreakpointFromManor } from 'ctm-components';

// manor
import { Button } from '@comparethemarketau/manor-button';

// redux
import { connect } from 'react-redux';

const useStyles = createUseStyles((theme) => ({
    hideButtonContainer: {
        alignSelf: 'center'
    },
    xs: {
        fontSize: theme.fontSize.xs
    }
}));

const _HideButon = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { selectedExcessValue, hideProductsWithExcess, isHideHighExcess } = props;

    const handleClick = () => {
        hideProductsWithExcess(!isHideHighExcess);
    };

    return (
        <div className={classes.hideButtonContainer}>
            <Button
                id="hide-products-with-excess-button"
                trackingLabel={`Hide products with an excess higher then $${selectedExcessValue}`}
                variant="secondary"
                handleClick={handleClick}
                className={classNames(classes.button, getBreakpointFromManor() === 'xs' && classes.xs)}
                style={{ margin: 0 }}
            >
                { !isHideHighExcess ? `Hide products with an excess higher than $${selectedExcessValue}` : 'Return to all products'}
            </Button>
        </div>
    );
};

_HideButon.propTypes = {
    selectedExcessValue: PropTypes.string.isRequired,
    isHideHighExcess: PropTypes.bool,
    // redux func
    hideProductsWithExcess: PropTypes.func
};

const mapDispatchToProps = (dispatch) => {
    return {
        hideProductsWithExcess: (hide) => {
            dispatch({
                type: 'SET_PAGE_VALUE',
                identifier: 'isHideHighExcess',
                value: hide
            });
        }
    };
};

const HideButon = connect(null, mapDispatchToProps)(_HideButon);

export { HideButon, _HideButon };
